import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  UpdatesLabel,
  GridContainerTemplates,
  Container,
  Header,
  BoxSearch,
  WrapperInput,
  ButtonSearch,
  ContainerIcon,
  ContainerInput,
  FullContent,
  WrapperPagination,
  FlexWrapper,
  BoxSearchMyProjects
} from "./styles";
import Template from "../components/Template";
import api from "../../../services/api";
import { AllMyProjects } from "../../../dtos/AllMyProjects";
import { useNavigate } from "react-router-dom";
import { useMainHook } from "../../../hooks/main";
import { FlexPagination } from "../../myclausules/screen/styles";
import Pagination from "../../../shared/components/Pagination";
import { LoadingFlex } from "../../login/pages/Login/styles";

import { ContractAnimation } from "../../../shared/components/ContractAnimation";
import { useAuth } from "../../../hooks/auth";
import { TextEmpy } from "../../myAutomations/screen/styles";

interface ParamsAllMyProjectsProps {
  search: string;
  pagination: number;
}

const MyProjects: React.FC = () => {
  const { permissionType } = useAuth();
  const [templateIDSelectedPopUp, setTemplateIDSelectedPopUp] =
    useState<string>("");
  const [copyDocument, setCopyDocument] = useState(false);
  const navigator = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const {
    documentID,
    objectScreen,
    setObjectScreen,
    currentTemplateInfo,
    documentName
  } = useMainHook();
  const [loading, setLoading] = useState(true);
  const [searchProjects, setSearchProjects] = useState("");
  const [params, setParams] = useState({
    search: "",
    pagination: 0
  } as ParamsAllMyProjectsProps);

  const [allMyProjects, setAllMyProjects] = useState<AllMyProjects[]>([]);

  //params for search to editing data of main state
  useEffect(() => {
    (async () => {
      try {
        const fetchAllMyTemplates = await api.get("user-templates", {
          params: {
            search: params.search ? params.search : null,
            pagination: params.pagination
          }
        });
        setAllMyProjects(fetchAllMyTemplates.data.dataArray as AllMyProjects[]);
        setTotalPages(fetchAllMyTemplates.data.pagination);
        setLoading(false);
      } catch (error) {
        console.log("ERROR GETTING TEMPLATES " + error);
        setLoading(false);
      }
    })();
  }, [copyDocument, params]);

  // Closing popUp
  useEffect(() => {
    window.addEventListener("click", (event: any) => {
      let aboutElement = event.target.getAttribute("about");
      if (aboutElement !== "button-popup") setTemplateIDSelectedPopUp("");
    });
  }, []);

  // search projects editing params dispatch we useEffect for allmyprojects data
  const handleClickSearch = useCallback(() => {
    setParams(state => {
      return {
        ...state,
        search: searchProjects
      };
    });
  }, [searchProjects]);

  const handleChooseTemplate = async (myProject: AllMyProjects) => {
    //currentTemplateInfo.current = myProject;
    documentID.current = myProject.id;
    currentTemplateInfo.current = myProject;
    documentName.current = myProject.title;

    try {
      const response = await api.get(`user-templates/${myProject.id}`);

      setObjectScreen(response.data.template.arrayOfPages);
      navigator(`editor/my-template/${myProject.id}`);
    } catch (err) {
      console.log(err, "error when get specific template");
    }
  };

  const handleDeleteDocument = async (document_id: string) => {
    try {
      if (window.confirm("Tem certeza que deseja excluir este documento ?")) {
        await api.delete(`user-templates/${document_id}`);

        setAllMyProjects(prevState => {
          let newArray = prevState.filter(document => {
            return document.id !== document_id;
          });

          return newArray;
        });
      } else {
      }
    } catch (error) {
      console.log("error trying to delete document", error);
    }
  };

  const handleMakeCopyDocument = useCallback(
    async (id: string) => {
      const newProject = {
        template: {
          arrayOfPages: [{ pageNumber: 1, renderObjects: [] }]
        },
        title: "COPIA",
        description: "Copia",
        is_automation: false
      };

      let imageThumbnail = null;

      try {
        const responseFetchTemplate = await api.get(`user-templates/${id}`);
        // setCopyDocument(responseFetchTemplate.data.template.arrayOfPages);
        newProject.template.arrayOfPages =
          responseFetchTemplate.data.template.arrayOfPages;
        newProject.title = `${responseFetchTemplate.data.title} - Copy`;

        try {
          const request = await api.post("user-templates", newProject);
          const idNewProject = request.data.id;

          setCopyDocument(!copyDocument);
        } catch (err) {
          console.log(err, "ERROR WHEN CREATED NEW TEMPLATE");
        }
      } catch (err) {
        console.log(err, "ERROR when fetch template by id");
      }
    },
    [copyDocument]
  );

  const handleChangeDocumentName = useCallback(
    (userDocument: AllMyProjects, newDocumentName: string) => {
      try {
        api.put("user-templates", {
          user_template_id: userDocument.id,
          template: {
            ...userDocument.template
          },
          title: newDocumentName,
          description: userDocument.description
        });
      } catch (error: any) {
        console.log(
          "Error trying to update document's name",
          error.response.data
        );
      }
    },
    []
  );

  return (
    <FullContent>
      {loading ? (
        <LoadingFlex>
          <ContractAnimation />
        </LoadingFlex>
      ) : (
        <Container>
          <Header>
            <UpdatesLabel>Meus projetos</UpdatesLabel>
          </Header>

          <BoxSearchMyProjects>
            <WrapperInput>
              <ContainerIcon>
                <img
                  src={"./images/icon-search.svg"}
                  className="icon-search-input"
                  alt=""
                />
              </ContainerIcon>
              <ContainerInput>
                <input
                  type="text"
                  value={searchProjects}
                  onChange={e => setSearchProjects(e.target.value)}
                />
              </ContainerInput>
            </WrapperInput>
            <ButtonSearch onClick={handleClickSearch}>PESQUISAR</ButtonSearch>
          </BoxSearchMyProjects>

          <FlexWrapper>
            {allMyProjects.length > 0 ? (
              <GridContainerTemplates>
                {allMyProjects.map((item, index) => {
                  let defaultIMG = false;
                  let splitURL = item.thumbnail_url.split("/");

                  if (splitURL[splitURL.length - 1] === "default")
                    defaultIMG = true;

                  return (
                    <Template
                      key={String(Math.random())}
                      userDocument={item}
                      handleChangeDocumentName={handleChangeDocumentName}
                      index={1}
                      handleChooseTemplate={() => {
                        handleChooseTemplate(item);
                      }}
                      handleDelete={() => {
                        handleDeleteDocument(item.id);
                      }}
                      handleDownload={() => {}}
                      handleChangeProjectsName={() => {}}
                      handleMakeCopy={() => handleMakeCopyDocument(item.id)}
                      templateIDSelectedPopUp={templateIDSelectedPopUp}
                      setTemplateIDSelectedPopUp={setTemplateIDSelectedPopUp}
                      name={item.title}
                      typePermission={permissionType}
                      url={
                        defaultIMG
                          ? "https://picnic.com.br/wp-content/uploads/2017/12/pagina-em-branco-catalogo-1.jpg"
                          : item.thumbnail_url
                      }
                    />
                  );
                })}
              </GridContainerTemplates>
            ) : (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "50vh",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center"
                }}
              >
                <TextEmpy>Nenhum projeto encontrado.</TextEmpy>
              </div>
            )}
          </FlexWrapper>
        </Container>
      )}

      {allMyProjects.length > 0 && (
        <WrapperPagination>
          <FlexPagination>
            <Pagination
              total={totalPages}
              offset={params.pagination}
              setDataParams={setParams}
              dataParams={params}
            />
          </FlexPagination>
        </WrapperPagination>
      )}
    </FullContent>
  );
};

export default MyProjects;
